import { string } from "prop-types";


let klineInterval: string = "";
let interval = localStorage ? localStorage.getItem("crpklineInterval") : "";
if (interval && interval != "")
    klineInterval = `_${interval}`;

export default klineInterval;